// removed by extract-text-webpack-plugin
module.exports = {"icon-container":"style__icon-container___3kU0W","icon":"style__icon___27qKY"};


//////////////////
// WEBPACK FOOTER
// ./components/TrainingTypeIcon/style.scss
// module id = 1378
// module chunks = 0